Vue.directive("fallback-icon", {
	bind: function(el) {
		const setFallBackImage = () => {
			console.log("error-file", el);
			el.src = "/static/img/misc/no-app-icon.svg";
		};

		el.addEventListener("error", () => {
			setFallBackImage();
		});

		if (!el.src) {
			setFallBackImage();
		}
	}
});



// WEBPACK FOOTER //
// ./src/directives.js